import { render, staticRenderFns } from "./SearchModuleSIPE.vue?vue&type=template&id=4c5a3ad0&scoped=true"
import script from "./SearchModuleSIPE.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchModuleSIPE.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SearchModuleSIPE.vue?vue&type=style&index=0&id=4c5a3ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5a3ad0",
  null
  
)

export default component.exports